const customFieldsConstants = {
    COMPONENT: 'Component',
    COMPONENTS: {
        IELTSACR: 'IELTSACR',
        IELTSGTR: 'IELTSGTR',
    },

    ITEM_COMPULSORY: 'Compulsory',
    ITEM_FLOW_CHART_COMPLETION_OBJECTIVE: 'Flow-chart Completion Objective',
    ITEM_MATCHING_1: 'Listening Matching 1',
    ITEM_MATCHING_2: 'Listening Matching 2',
    ITEM_MATCHING_FEATURES: 'Matching Features',
    ITEM_MATCHING_HEADING: 'Matching Headings',
    ITEM_MATCHING_INFORMATION: 'Matching Information',
    ITEM_MATCHING_PLAN_MAP_DIAGRAM_LABELLING: 'Plan, Map, Diagram Labelling',
    ITEM_MATCHING_SENTENCE_ENDING: 'Matching Sentence Endings',
    ITEM_MATCHING: 'Matching',
    ITEM_MULTI_ANSWER: 'MC Questions (multi-answer)',
    ITEM_RUBRIC_BLANK_1: 'Item Rubric Blank 1',
    ITEM_RUBRIC_BLANK_2: 'Item Rubric Blank 2',
    ITEM_RUBRIC_BLANK_3: 'Item Rubric Blank 3',
    ITEM_RUBRIC_INTRODUCTION: 'Item Rubric Introduction',
    ITEM_RUBRIC_VARIANT: 'Item Rubric Variant',
    ITEM_SHORT_ANSWER_QUESTIONS: 'Short Answer Questions',
    ITEM_SUB_TYPE: 'Item Sub Type',
    ITEM_SUMMARY_COMPLETION_OBJECTIVE: 'Summary Completion Objective',
    ITEM_SUMMARY_COMPLETION_PRODUCTIVE: 'Summary Completion Productive',
    ITEM_TRUE_FALSE_NOTGIVEN: 'T-F-NG',
    ITEM_TYPE: 'Item Type',
    ITEM_YES_NO_NOTGIVEN: 'Y-N-NG',
    BLANK: 'blank',

    SECTION: 'Section',
    SPEAKING_TYPE: 'Speaking type',
    SPEAKING_TYPE_IB: 'Speaking type IB',
    STIMULUS_LAYOUT: 'Stimulus Layout',
    TEST_TYPE_LISTENING: 'Listening',
    TEST_TYPE_READING: 'Reading',
    TEST_TYPE_SPEAKING: 'Speaking',
    TEST_TYPE_WRITING: 'Writing',
    TESTING_FOCUS_LEVEL_1_FJORD: 'Testing Focus level 1',
    TESTING_FOCUS_LEVEL_1_CEQ: 'Testing Focus Level 1',

    stimulusLayoutValue: {
        STANDARD: 'Standard',
        SINGLE_COLUMN_TEXT: 'Single column text',
        TWO_COLUMN_TEXT: '2 column text',
        SINGLE_COLUMN_TEXT_WITH_LETTERS: 'Single column text with letters',
        TWO_COLUMN_TEXT_WITH_LETTERS: '2 column text with letters',
        SINGLE_COLUMN_NOTICE: 'Single column notices',
        TWO_COLUMN_NOTICE: '2 column notices',
        FORM: 'Form',
    },

    itemTypes: {
        MC_QUESTIONS: 'mCQuestions',
        MC_QUESTIONS_MULTI_ANSWER: 'mCQuestionsMultiAnswer',
        SHORT_ANSWER_QUESTIONS: 'shortAnswerQuestions',
    },
};

export default customFieldsConstants;
